module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_01b.3a88e810.jpg";